export default {
  DEFAULT_TITLE: "ダイアログ",
  ALERT_TITLE: "情報",
  CONFIRM_TITLE: "確認",
  PROMPT_TITLE: "入力",
  OK: "OK",
  CANCEL: "Cancel",
};
